import React from 'react';
interface SeasonalBalanceTabProps {
  searchTerm: string;
}
export function SeasonalBalanceTab({
  searchTerm
}: SeasonalBalanceTabProps) {
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-671">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-672">
        Dr. Tan's Seasonal Balance
      </h2>
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-673">
        <p className="text-gray-700 leading-relaxed" data-id="element-674">
          Seasonal Balance integrates the timing of treatment with Five Element
          theory. Each season has specific date ranges and corresponding point
          sequences that enhance treatment effectiveness when layered into
          protocols.
        </p>
      </div>
      <div className="space-y-6" data-id="element-675">
        <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-green-500" data-id="element-676">
          <h3 className="text-2xl font-bold text-green-600 mb-3" data-id="element-677">
            🌱 Wood Element Season
          </h3>
          <div className="bg-green-50 p-4 rounded-lg mb-4" data-id="element-678">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm" data-id="element-679">
              <div data-id="element-680">
                <strong className="text-green-800" data-id="element-681">Dates:</strong>
                <span className="text-green-700" data-id="element-682"> February 4 - April 16</span>
              </div>
              <div data-id="element-683">
                <strong className="text-green-800" data-id="element-684">Element:</strong>
                <span className="text-green-700" data-id="element-685"> Wood</span>
                <span className="mx-2" data-id="element-686">|</span>
                <strong className="text-green-800" data-id="element-687">Gua:</strong>
                <span className="text-green-700" data-id="element-688"> 45</span>
              </div>
              <div data-id="element-689">
                <strong className="text-green-800" data-id="element-690">Meridians:</strong>
                <span className="text-green-700" data-id="element-691"> Liver & Gallbladder</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-692">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-693">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-694">
                LIVER POINT SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-695">
                {['LIV-3', 'LIV-2', 'LIV-1', 'LIV-5', 'LIV-3', 'LIV-1', 'LIV-8', 'LIV-5', 'LIV-1', 'LIV-4', 'LIV-3', 'LIV-2'].map((point, index) => <span key={index} className="px-3 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium" data-id="element-696">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-697">
              <h4 className="font-semibold text-green-800 mb-3" data-id="element-698">
                GALLBLADDER POINT SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-699">
                {['GB-34', 'GB-38', 'GB-40', 'GB-34', 'GB-40', 'GB-43', 'GB-40', 'GB-41', 'GB-43', 'GB-34'].map((point, index) => <span key={index} className="px-3 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium" data-id="element-700">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-4" data-id="element-701">
            <strong className="text-yellow-800" data-id="element-702">Seasonal Tip:</strong>
            <span className="text-yellow-700" data-id="element-703">
              {' '}
              During Wood season, add 2-3 points from this sequence to any
              treatment for constitutional support.
            </span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-red-500" data-id="element-704">
          <h3 className="text-2xl font-bold text-red-600 mb-3" data-id="element-705">
            🔥 Fire Element Season
          </h3>
          <div className="bg-red-50 p-4 rounded-lg mb-4" data-id="element-706">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm" data-id="element-707">
              <div data-id="element-708">
                <strong className="text-red-800" data-id="element-709">Dates:</strong>
                <span className="text-red-700" data-id="element-710"> May 5 - July 20</span>
              </div>
              <div data-id="element-711">
                <strong className="text-red-800" data-id="element-712">Element:</strong>
                <span className="text-red-700" data-id="element-713"> Fire</span>
                <span className="mx-2" data-id="element-714">|</span>
                <strong className="text-red-800" data-id="element-715">Gua:</strong>
                <span className="text-red-700" data-id="element-716"> 36</span>
              </div>
              <div data-id="element-717">
                <strong className="text-red-800" data-id="element-718">Meridians:</strong>
                <span className="text-red-700" data-id="element-719"> Heart & Small Intestine</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-720">
            <div className="bg-red-50 p-4 rounded-lg" data-id="element-721">
              <h4 className="font-semibold text-red-800 mb-3" data-id="element-722">
                HEART POINT SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-723">
                {['HT-4', 'HT-5', 'HT-7', 'HT-5', 'HT-7', 'HT-8', 'HT-3', 'HT-5', 'HT-8', 'HT-4', 'HT-7', 'HT-9'].map((point, index) => <span key={index} className="px-3 py-1 bg-red-200 text-red-800 rounded-full text-sm font-medium" data-id="element-724">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-red-50 p-4 rounded-lg" data-id="element-725">
              <h4 className="font-semibold text-red-800 mb-3" data-id="element-726">
                SMALL INTESTINE SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-727">
                {['SI-8', 'SI-2', 'SI-1', 'SI-8', 'SI-5', 'SI-1', 'SI-5', 'SI-3', 'SI-1', 'SI-8', 'SI-4', 'SI-2'].map((point, index) => <span key={index} className="px-3 py-1 bg-red-200 text-red-800 rounded-full text-sm font-medium" data-id="element-728">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-yellow-500" data-id="element-729">
          <h3 className="text-2xl font-bold text-yellow-600 mb-3" data-id="element-730">
            ⛰️ Earth Element Seasons
          </h3>
          <div className="bg-yellow-50 p-4 rounded-lg mb-4" data-id="element-731">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm" data-id="element-732">
              <div data-id="element-733">
                <strong className="text-yellow-800" data-id="element-734">Dates:</strong>
                <span className="text-yellow-700" data-id="element-735">
                  {' '}
                  April 17-May 4, July 21-Aug 7, Oct 20-Nov 6, Jan 17-Feb 3
                </span>
              </div>
              <div data-id="element-736">
                <strong className="text-yellow-800" data-id="element-737">Element:</strong>
                <span className="text-yellow-700" data-id="element-738"> Earth</span>
                <span className="mx-2" data-id="element-739">|</span>
                <strong className="text-yellow-800" data-id="element-740">Gua:</strong>
                <span className="text-yellow-700" data-id="element-741"> 72</span>
              </div>
              <div data-id="element-742">
                <strong className="text-yellow-800" data-id="element-743">Meridians:</strong>
                <span className="text-yellow-700" data-id="element-744"> Spleen & Stomach</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-745">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-746">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-747">
                SPLEEN POINT SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-748">
                {['SP-9', 'SP-4', 'SP-2', 'SP-9', 'SP-5', 'SP-4', 'SP-5', 'SP-4', 'SP-3', 'SP-9', 'SP-2', 'SP-1'].map((point, index) => <span key={index} className="px-3 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium" data-id="element-749">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-yellow-50 p-4 rounded-lg" data-id="element-750">
              <h4 className="font-semibold text-yellow-800 mb-3" data-id="element-751">
                STOMACH POINT SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-752">
                {['ST-41', 'ST-43', 'ST-45', 'ST-43', 'ST-44', 'ST-45', 'ST-36', 'ST-44', 'ST-45', 'ST-41'].map((point, index) => <span key={index} className="px-3 py-1 bg-yellow-200 text-yellow-800 rounded-full text-sm font-medium" data-id="element-753">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mt-4" data-id="element-754">
            <strong className="text-blue-800" data-id="element-755">Note:</strong>
            <span className="text-blue-700" data-id="element-756">
              {' '}
              Earth season occurs 4 times per year between major seasons.
              Excellent for digestive support.
            </span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-gray-400" data-id="element-757">
          <h3 className="text-2xl font-bold text-gray-600 mb-3" data-id="element-758">
            🍃 Metal Element Season
          </h3>
          <div className="bg-gray-50 p-4 rounded-lg mb-4" data-id="element-759">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm" data-id="element-760">
              <div data-id="element-761">
                <strong className="text-gray-800" data-id="element-762">Dates:</strong>
                <span className="text-gray-700" data-id="element-763"> August 8 - October 19</span>
              </div>
              <div data-id="element-764">
                <strong className="text-gray-800" data-id="element-765">Element:</strong>
                <span className="text-gray-700" data-id="element-766"> Metal</span>
                <span className="mx-2" data-id="element-767">|</span>
                <strong className="text-gray-800" data-id="element-768">Gua:</strong>
                <span className="text-gray-700" data-id="element-769"> 18</span>
              </div>
              <div data-id="element-770">
                <strong className="text-gray-800" data-id="element-771">Meridians:</strong>
                <span className="text-gray-700" data-id="element-772"> Lung & Large Intestine</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-773">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-774">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-775">
                LUNG POINT SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-776">
                {['LU-5', 'LU-7', 'LU-11', 'LU-5', 'LU-10', 'LU-11', 'LU-9', 'LU-10', 'LU-11', 'LU-5', 'LU-7', 'LU-8'].map((point, index) => <span key={index} className="px-3 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium" data-id="element-777">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-778">
              <h4 className="font-semibold text-gray-800 mb-3" data-id="element-779">
                LARGE INTESTINE SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-780">
                {['LI-4', 'LI-3', 'LI-2', 'LI-5', 'LI-4', 'LI-3', 'LI-11', 'LI-5', 'LI-4', 'LI-3', 'LI-2', 'LI-1'].map((point, index) => <span key={index} className="px-3 py-1 bg-gray-200 text-gray-800 rounded-full text-sm font-medium" data-id="element-781">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md border-l-4 border-blue-900" data-id="element-782">
          <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-783">
            ❄️ Water Element Season
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-784">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm" data-id="element-785">
              <div data-id="element-786">
                <strong className="text-blue-900" data-id="element-787">Dates:</strong>
                <span className="text-blue-800" data-id="element-788"> November 7 - January 16</span>
              </div>
              <div data-id="element-789">
                <strong className="text-blue-900" data-id="element-790">Element:</strong>
                <span className="text-blue-800" data-id="element-791"> Water</span>
                <span className="mx-2" data-id="element-792">|</span>
                <strong className="text-blue-900" data-id="element-793">Gua:</strong>
                <span className="text-blue-800" data-id="element-794"> 65</span>
              </div>
              <div data-id="element-795">
                <strong className="text-blue-900" data-id="element-796">Meridians:</strong>
                <span className="text-blue-800" data-id="element-797"> Kidney & Bladder</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-798">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-799">
              <h4 className="font-semibold text-blue-900 mb-3" data-id="element-800">
                KIDNEY POINT SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-801">
                {['KI-3', 'KI-2', 'KI-1', 'KI-7', 'KI-3', 'KI-1', 'KI-10', 'KI-7', 'KI-1', 'KI-4', 'KI-3', 'KI-2'].map((point, index) => <span key={index} className="px-3 py-1 bg-blue-200 text-blue-900 rounded-full text-sm font-medium" data-id="element-802">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-803">
              <h4 className="font-semibold text-blue-900 mb-3" data-id="element-804">
                BLADDER POINT SEQUENCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-805">
                {['BL-40', 'BL-60', 'BL-64', 'BL-40', 'BL-64', 'BL-66', 'BL-64', 'BL-65', 'BL-66', 'BL-40'].map((point, index) => <span key={index} className="px-3 py-1 bg-blue-200 text-blue-900 rounded-full text-sm font-medium" data-id="element-806">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-orange-50 border-l-4 border-orange-500 p-6 mt-8" data-id="element-807">
        <strong className="text-orange-800 text-lg" data-id="element-808">
          How to Layer Seasonal Points:
        </strong>
        <ul className="mt-3 space-y-2 text-orange-700" data-id="element-809">
          <li data-id="element-810">• Check current date and identify active season</li>
          <li data-id="element-811">• Select 2-4 points from the seasonal sequence</li>
          <li data-id="element-812">• Add to your primary Balance Method treatment</li>
          <li data-id="element-813">• Timing enhances treatment effectiveness significantly</li>
          <li data-id="element-814">• Combine with Global Balance for maximum effect</li>
        </ul>
      </div>
    </div>;
}